import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import PropTypes from 'prop-types';
import { CheckCircleOutlined, Schedule } from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(0, 1),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '100px',
        height: '32px'
    },
    message: {
        padding: '4px 0',
        fontWeight: 'bold',
        fontSize: '0.85rem'
    },
    icon: {
        padding: '4px 0',
        marginRight: theme.spacing(0.5)
    }
}));

export const STATUS_APROVADO = 'A';
export const STATUS_EM_ANALISE = 'E';

export default function StatusDocumento(props) {
    const { status } = props;
    const classes = useStyles();

    switch (status) {
        case STATUS_APROVADO:
            return (
                <Alert
                    variant="filled"
                    severity="success"
                    icon={<CheckCircleOutlined fontSize="inherit" />}
                    classes={{ root: classes.root, message: classes.message, icon: classes.icon }}
                >
                    Aprovado
                </Alert>
            );
        case STATUS_EM_ANALISE:
        default:
            return (
                <Alert
                    variant="filled"
                    severity="info"
                    icon={<Schedule fontSize="inherit" />}
                    classes={{ root: classes.root, message: classes.message, icon: classes.icon }}
                >
                    Em Análise
                </Alert>
            );
    }
}

StatusDocumento.propTypes = {
    status: PropTypes.string.isRequired
};
